import { withCompInfo } from '@wix/editor-elements-integrations'
import { minimumLabelFontSize } from '../../core/carmi/InputUtils/constants'
import { ComboBoxInputCSSVars, ComboBoxInputDefinition } from './ComboBoxInput'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { getCrossEditorsCssVars } from './common'
import { getInputHeightInPx, getLabelPaddingObject } from '../../core/mappers/inputUtils'
import { getHeightInPixels } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<ComboBoxInputCSSVars, ComboBoxInputDefinition>()(
	[
		'compProps',
		'hasResponsiveLayout',
		'compLayout',
		'compSingleLayout',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		'isOneDocMigrated',
	],
	({
		compProps,
		hasResponsiveLayout,
		compLayout,
		compSingleLayout,
		styleProperties,
		siteFonts,
		isMobileView,
		isOneDocMigrated,
	}) => {
		const { textAlignment, labelMargin, labelMobileFontSize, inputHeight, inputHeightMobile } = compProps
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
		const sharedVars = {
			'--arrowLeftPosition': textAlignment === 'right' ? '0' : 'auto',
			'--arrowRightPosition': textAlignment === 'right' ? 'auto' : '0',
			'--labelMarginBottom': `${labelMargin}px`,
			'--fntlbl': getScaledFont(compInfo, 'fntlbl', isOneDocMigrated, labelMobileFontSize, minimumLabelFontSize),
			'--requiredIndicationDisplay':
				styleProperties.txtlblrq && styleProperties.txtlblrq !== 'transparent' ? 'inline' : 'none',
			...getCrossEditorsCssVars(compInfo, compProps, isOneDocMigrated),
			...getLabelPaddingObject(compProps),
		}
		const height = isOneDocMigrated ? getHeightInPixels(compSingleLayout) : compLayout.height
		return hasResponsiveLayout
			? sharedVars
			: {
					...sharedVars,
					...(!isOneDocMigrated && {
						height: 'auto',
					}),
					'--inputHeight': getInputHeightInPx({
						isMobileView,
						height: height!,
						inputHeight: inputHeight!,
						inputHeightMobile: inputHeightMobile!,
					}),
			  }
	}
)
